import { blues, grays, oranges, turquoises } from './palette'

const breakpoints = ['480px', '768px', '1024px']

export const colors = {
  text: grays.N800,
  primary: turquoises.T300,
  secondary: blues.A800,
  white: grays.N000,
  black: grays.N900,
  warning: 'rgb(210,0,51)',
  blues,
  turquoises,
  oranges,
  grays,
  error: '#ED3024',
  success: '#43A047',
}

export const fonts = {
  body: '"Nunito Sans", sans-serif',
}

export const fontSizes = [
  '0.75em', // 12px
  '1em', // 16px
  '1.125em', // 18px
  '1.25em', // 20px
  '1.5em', // 24px
  '2em', // 32px
  '3.25em', // 52px
]
fontSizes.body = fontSizes[1]
fontSizes.h1 = fontSizes[6]
fontSizes.h2 = fontSizes[5]
fontSizes.h3 = fontSizes[4]
fontSizes.h4 = fontSizes[3]
fontSizes.h5 = fontSizes[1]
fontSizes.button = fontSizes[2]
fontSizes.label = fontSizes[0]
fontSizes.link = fontSizes[2]

export const fontWeights = [
  400, // Regular
  700, // Bold
  800, // Extra Bold
]
fontWeights.regular = fontWeights[0]
fontWeights.bold = fontWeights[1]
fontWeights.extraBold = fontWeights[2]

export const radii = ['8px']
radii.default = radii[0]

export const shadows = {
  under: [
    '0px 2px 1px rgba(0, 0, 0, 0.1)',
    '0px 2px 3px rgba(0, 0, 0, 0.3)',
    '0px 3px 8px rgba(0, 0, 0, 0.24), 0px 3px 12px rgba(0, 0, 0, 0.12)',
    '0px 7px 12px rgba(83, 104, 111, 0.12), 0px 11px 15px rgba(85, 97, 115, 0.1)',
    '0px 12px 24px rgba(0, 0, 0, 0.23), 0px 30px 80px rgba(0, 0, 0, 0.25)',
    '0px 30px 42px rgba(0, 0, 0, 0.22), 0px 42px 112px rgba(0, 0, 0, 0.25)',
    '0px 45px 48px rgba(0, 0, 0, 0.22), 0px 57px 152px rgba(0, 0, 0, 0.3)',
  ],
  over: [
    '0px -2px 1px rgba(0, 0, 0, 0.1)',
    '0px -2px 3px rgba(0, 0, 0, 0.3)',
    '0px -3px 8px rgba(0, 0, 0, 0.24), 0px -3px 12px rgba(0, 0, 0, 0.12)',
    '0px -9px 24px rgba(0, 0, 0, 0.23), 0px -9px 24px rgba(0, 0, 0, 0.12)',
    '0px -12px 24px rgba(0, 0, 0, 0.23), 0px -30px 80px rgba(0, 0, 0, 0.25)',
    '0px -30px 42px rgba(0, 0, 0, 0.22), 0px -42px 112px rgba(0, 0, 0, 0.25)',
    '0px -45px 48px rgba(0, 0, 0, 0.22), 0px -57px 152px rgba(0, 0, 0, 0.3)',
  ],
}
shadows.buttons = {
  default: shadows.under[1],
  hover: shadows.under[3],
}

export const variants = {
  card: {
    boxShadow: shadows.under[2],
    borderRadius: '8px',
  },
}

export default {
  breakpoints,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  radii,
  shadows,
  variants,
}
